import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import cn from 'classnames';
import React from 'react';

import type { Toggle as Props } from './toggle.types';

const Toggle: React.FC<Props> = ({ label, options }) => (
  <div aria-label={label} className="toggle" role="radiogroup">
    {options.map(({ description, href, id, label, onClick, selected }) => (
      <a
        aria-checked={Boolean(selected)}
        className={cn('toggle__option', {
          'toggle__option--selected': selected,
        })}
        href={href}
        key={id}
        onClick={onClick}
        onKeyDown={event => {
          if (event.key === ' ') {
            event.preventDefault();
            event.currentTarget.click();
          }
        }}
        role="radio"
      >
        <Text size={Text.sizes.basic} theme={Text.themes.emphasis}>
          {label}
        </Text>
        {description ? (
          <Text size={Text.sizes.small} variant={Text.variants.content}>
            {description}
          </Text>
        ) : null}
      </a>
    ))}
  </div>
);

export default Toggle;
